import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* global window */
import hasDom from 'has-dom';
import { injectScript, waitUntil } from 'atc-js';
var gtmLoaded = false;
var isPageTagSent = false;
var removePageExitListener = function removePageExitListener() {};
function resetIsPageTagSent() {
  isPageTagSent = false;
}
export default function ensureGoogleAnalytics(_x, _x2, _x3) {
  return _ensureGoogleAnalytics.apply(this, arguments);
}
function _ensureGoogleAnalytics() {
  _ensureGoogleAnalytics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options, callback, _temp) {
    var _initialConfig$google, _initialConfig$google2;
    var _ref, _ref$history, history, _ref$isPageEvent, isPageEvent, _options$initialConfi, initialConfig, _options$disableGTM, disableGTM, _options$disableGTMEv, disableGTMEvents, _options$skipPageEven, skipPageEvent, gtmContainerCode, dynamicDataLayer, sendEvent, _history$eventListene, _history$eventListene2, on, _history$eventListene3, off, _history$eventListene4, pageExitEvent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _temp === void 0 ? {} : _temp, _ref$history = _ref.history, history = _ref$history === void 0 ? {} : _ref$history, _ref$isPageEvent = _ref.isPageEvent, isPageEvent = _ref$isPageEvent === void 0 ? false : _ref$isPageEvent;
          _options$initialConfi = options.initialConfig, initialConfig = _options$initialConfi === void 0 ? {} : _options$initialConfi, _options$disableGTM = options.disableGTM, disableGTM = _options$disableGTM === void 0 ? false : _options$disableGTM, _options$disableGTMEv = options.disableGTMEvents, disableGTMEvents = _options$disableGTMEv === void 0 ? true : _options$disableGTMEv, _options$skipPageEven = options.skipPageEvent, skipPageEvent = _options$skipPageEven === void 0 ? false : _options$skipPageEven; // GA is currently a client-only solution so ensure we only process on the client
          // abort if we are on the server or if GTM is disabled
          if (!(disableGTM || !hasDom())) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          gtmContainerCode = (initialConfig == null ? void 0 : (_initialConfig$google = initialConfig.google) == null ? void 0 : _initialConfig$google.gtmCode) || '';
          dynamicDataLayer = initialConfig == null ? void 0 : (_initialConfig$google2 = initialConfig.google) == null ? void 0 : _initialConfig$google2.dataLayerName;
          if (!gtmLoaded && gtmContainerCode) {
            gtmLoaded = new Promise(function (resolve) {
              if (dynamicDataLayer) {
                window[dynamicDataLayer] = window[dynamicDataLayer] || [];
                window[dynamicDataLayer].push({
                  'gtm.start': new Date().getTime(),
                  event: 'gtm.js'
                });
              }
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
              });
              if (dynamicDataLayer) {
                window[dynamicDataLayer] = window.dataLayer || [];
              }

              // if window.dataLayer is returned instead of resolve(true), the analytics:pageReady event won't fire
              return injectScript("//www.googletagmanager.com/gtm.js?id=" + gtmContainerCode).then(function () {
                return resolve(true);
              });
            });
          }

          // eslint-disable-next-line consistent-return
          sendEvent = function sendEvent() {
            if (typeof callback === 'function' && !disableGTMEvents) {
              return callback(window.dataLayer);
            }
          };
          try {
            if (isPageEvent) {
              removePageExitListener();
              isPageTagSent = true;

              // legacy support
              if (history.listen) {
                removePageExitListener = history.listen(resetIsPageTagSent);
              }

              // eventListener support
              if (history.eventListener) {
                _history$eventListene = history.eventListener, _history$eventListene2 = _history$eventListene.on, on = _history$eventListene2 === void 0 ? function () {} : _history$eventListene2, _history$eventListene3 = _history$eventListene.off, off = _history$eventListene3 === void 0 ? function () {} : _history$eventListene3, _history$eventListene4 = _history$eventListene.pageExitEvent, pageExitEvent = _history$eventListene4 === void 0 ? '' : _history$eventListene4;
                on(pageExitEvent, resetIsPageTagSent);
                removePageExitListener = function removePageExitListener() {
                  off(pageExitEvent, resetIsPageTagSent);
                };
              }
              sendEvent();
            } else {
              waitUntil(function () {
                return isPageTagSent || skipPageEvent;
              }, function () {
                sendEvent();
              }, 30, 15000);
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('GA360: Failed to Send Event: ', error);
            window.newrelic.noticeError('GA360: Failed to Send Event ' + error);
          }
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ensureGoogleAnalytics.apply(this, arguments);
}